import { render, staticRenderFns } from "./ReviewBody.vue?vue&type=template&id=2276eaf8&scoped=true&"
import script from "./ReviewBody.vue?vue&type=script&lang=js&"
export * from "./ReviewBody.vue?vue&type=script&lang=js&"
import style0 from "./ReviewBody.vue?vue&type=style&index=0&id=2276eaf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2276eaf8",
  null
  
)

export default component.exports